import { useState, useEffect, useRef } from 'react'
import { ArrowBackIcon, CloseIcon, SearchIcon, SmallCloseIcon } from '@chakra-ui/icons'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogOverlay,
  Badge,
  Box,
  Button,
  CloseButton,
  Divider,
  Flex,
  FormControl,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  SimpleGrid,
  Spacer,
  Spinner,
  Stack,
  Text,
  useDisclosure,
  useMediaQuery,
  VStack
} from '@chakra-ui/react'
import { Link, useNavigate } from 'react-router-dom'
import { Toaster, toast } from 'react-hot-toast'

import useProduct from '../../hooks/useProduct'
import ProductImage from '../../components/ProductImage'
import FilterCheckboxMobile from '../../components/FilterCheckboxMobile'
import FilterCheckbox from '../../components/FilterCheckbox'
import clientAxios from '../../config/axios'
const quilmesImages = require.context('../../assets/images', true)

const Products = () => {
  const { productsBackend, loadingProducts } = useProduct()
  const [productsApi, setProducts] = useState([])
  const [object, setObject] = useState([])
  const [search, setSearch] = useState('')
  const [priceValue, setPrice] = useState('')
  const [idBackend, setIdBackend] = useState('')
  const [errorProducts, setErrorProducts] = useState('')
  const [productsDescrtion, setProductsDescrtion] = useState({
    brand: '',
    material: '',
    returnability: '',
    volume: ''
  })
  const [errorId, setErrorId] = useState(0)
  const [error, setError] = useState('')
  const [edit, setEdit] = useState(false)
  const [loading, setLoading] = useState(true)
  const [loadingProductsArea, setLoadingProductsArea] = useState(true)
  const [existProduct, setExistProduct] = useState(false)
  const [Checked, setChecked] = useState([])
  const [average, setAverage] = useState({})
  const [productsStorage, setProductsStorage] = useState(() => {
    const productsStorage = sessionStorage.getItem('products')

    return productsStorage ? JSON.parse(productsStorage) : []
  })
  const [isLargerThan768] = useMediaQuery('(max-width: 780px)')
  const sizes = ['full']
  const navigate = useNavigate()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = useRef()

  const [erroresId, setErroresId] = useState([])
  const [dataArea, setDataArea] = useState([])
  const [productsArea, setProductsArea] = useState([])
  const areaSeleccionada = sessionStorage.getItem('geoAreaSelect')

  const { geoAreaId } = JSON.parse(areaSeleccionada)

  useEffect(() => {
    const obtenerProductos = async () => {
      clientAxios.get('/product/all/' + geoAreaId).then((response) => {
        const filteredData = response.data.products.filter(({ brand, material, volume, returnability }) => brand !== null && material !== null && volume !== null && returnability !== null)

        setDataArea(filteredData)
        setLoadingProductsArea(false)
      }).catch((error) => {
        console.log(error)
      })
    }

    obtenerProductos()
  }, [])

  useEffect(() => {
    setProductsArea(dataArea)
  }, [dataArea])

  useEffect(() => {
    if (loadingProducts || loadingProductsArea) {
      return
    }

    setProducts(productsArea)
  }, [loadingProducts])

  /* The above code is checking if the price exists in the productsStorage. If it does, it will set the
  object to the productsStorage. */
  useEffect(() => {
    const ifPriceExist = () => {
      setObject(productsStorage)
    }

    ifPriceExist()
  }, [])

  /* The above code is checking if the productsApi array is empty. If it is empty, it will return. If
  it is not empty, it will check if the existProduct is false. If it is false, it will loop through
  the productsApi array and the productsStorage array. If the product id is equal to the object id,
  it will set the product price to the object price. If the existProduct is true, it will set the
  existProduct to true. */
  useEffect(() => {
    if (productsApi.length === 0) {
      return
    }

    if (!existProduct) {
      productsApi.forEach((product) => {
        productsStorage.forEach((object) => {
          if (product.id === object.id) {
            product.price = '$' + object.price
          }
        })
      })
    }

    setExistProduct(true)
  }, [productsApi, existProduct, object])

  useEffect(() => {
    const ifAveragePriceIsGreaterThanZero = () => {
      if (average.length > 0) {
        average.forEach((item) => {
          productsArea.forEach((product) => {
            if (item.productId === product.id) {
              if (item.averagePrice > 0) {
                setErroresId((erroresId) => [...erroresId, product.id])
              }
            }
          })
        })
      }
    }

    ifAveragePriceIsGreaterThanZero()
  }, [average])

  /* Setting the loading state to false after 1 second. */
  setTimeout(() => {
    setLoading(false)
    setLoadingProductsArea(false)
  }, 2000)

  /* Showing a loading spinner while the data is being fetched. */
  if (loading || loadingProductsArea) {
    return (
      <Box
        alignItems='center'
        display='flex'
        flexDirection='column'
        h='100vh'
        justifyContent='center'
        w='100vw'
      >
        <Spinner
          color='orange'
          emptyColor='gray.200'
          size='xl'
          speed='0.75s'
          thickness='4px'
        />
        <Text paddingTop={2}>Obteniendo productos...</Text>
      </Box>
    )
  }

  if (productsArea === undefined) {
    return (
      <Box
        alignItems='center'
        display='flex'
        flexDirection='column'
        h='100vh'
        justifyContent='center'
        w='100vw'
      >
        <Spinner
          color='orange'
          emptyColor='gray.200'
          size='xl'
          speed='0.75s'
          thickness='4px'
        />
        <Text paddingTop={2}>Obteniendo productos...</Text>
      </Box>
    )
  }

  const filteredProducts = productsArea.filter((product) => {
    if (Checked.length === 0 && search === '') {
      return product
    }

    if (Checked.length > 0) {
      if (search !== '') {
        setSearch('')
      }

      return Checked.every((checked) => {
        return product.volume.description === checked || product.brand.description === checked || product.material.description === checked || product.returnability.description === checked
      })
    }

    return (
      product.brand.description.toLowerCase().includes(search.toLowerCase()) ||
      product.returnability.description
        .toLowerCase()
        .includes(search.toLowerCase()) ||
      product.volume.description.toLowerCase().includes(search.toLowerCase()) ||
      product.material.description.toLowerCase().includes(search.toLowerCase())
    )
  })

  /**
  * The function takes in an event as an argument, and sets the search state to the value of the input
  * field
  * @param e - the event object
  */
  const handleSearch = (e) => {
    setSearch(e.target.value)
  }

  /**
   * It takes an event and an id as arguments, sets the idBackend state to the id argument, sets the
   * price state to the value of the event target, finds the product with the id that matches the id
   * argument, and sets the brandDescription, materialDescription, returnabilityDescription, and
   * volumeDescription states to the description properties of the product
   * @param e - the event object
   * @param id - the id of the product
   */
  const handleChange = (e, id) => {
    setIdBackend(id)
    setPrice(e.target.value)

    const product = productsArea.find((product) => product.id === id)

    setProductsDescrtion({
      brand: product.brand,
      material: product.material,
      returnability: product.returnability,
      volume: product.volume
    })
  }

  /**
 * It sets the error and errorId to an empty string, sets the edit state to true, and then sets the
 * price state to the product's price
 * @param id - The id of the product
 * @returns the price and idBackend.
 */
  const handleFocus = (id) => {
    setError('')
    setErrorId('')
    setEdit(true)

    const product = object.find((product) => product.id === id)

    if (idBackend !== id) {
      setPrice(product.price)
      setIdBackend(id)

      return
    }

    if (product) {
      const price = priceValue.replace('$', '')

      setPrice(price)
      setObject([...object])
    }
  }

  /**
   * It removes the products from the session storage
   */
  const handleReturn = () => {
    sessionStorage.removeItem('products')
  }

  /**
   * It adds a product to the list of products
   * @returns the price and the id of the product.
   */
  const addingProduct = () => {
    setEdit(false)
    // const regEx = /^[0-9]+([,.][0-9]+)?$/
    const regEx = /^[0-9]+([0-9.,]+)?$/
    // const regEx = /^[0-9]+([,][0-9]{1,2})?$/
    const min = 0
    const max = 9999.99
    const product = object.find((product) => product.id === idBackend)
    let priceTest

    if (product) {
      if (!regEx.test(priceValue)) {
        product.price = ''
        setError('El valor ingresado no es válido.')
        setErrorId(idBackend)
        setPrice('')
        setIdBackend('')

        return
      } else if (priceValue <= min) {
        product.price = priceValue
        setError('El precio no debe ser 0')
        setErrorId(idBackend)
        setPrice('')
        setIdBackend('')

        return
      } else if (priceValue >= max) {
        product.price = priceValue
        setError('El precio no debe ser mayor a 9999.99')
        setErrorId(idBackend)
        setPrice('')
        setIdBackend('')

        return
      }
      if (priceValue.includes(',')) {
        if (priceValue.split(',')[0] > max) {
          product.price = priceValue
          setError('El precio no debe ser mayor a 9999.99')
          setErrorId(idBackend)
          setPrice('')
          setIdBackend('')

          return
        }
      }
      if (priceValue === '0,0' || priceValue === '0,00') {
        product.price = priceValue
        setError('El precio no debe ser 0')
        setErrorId(idBackend)
        setPrice('')
        setIdBackend('')

        return
      }

      if (priceValue.includes(',') && priceValue.includes('.')) {
        const price = priceValue.replace('.', '')

        priceTest = '$' + price.replace(/(\d{2})\d+$/, '$1')

        adding(idBackend, priceTest)

        setError('')
        setPrice('')
        setIdBackend('')

        return
      }

      if (priceValue.includes(',')) {
        priceTest = '$' + priceValue.replace(/(\d{2})\d+$/, '$1')
        // Si tiene un solo despues de la coma agregar un 0 al final
        if (priceValue.split(',')[1].length === 1) {
          priceTest = priceTest + '0'
        }
      } else {
        priceTest = '$' + priceValue
      }

      if (priceTest.includes('.')) {
      // si el precio tiene punto, se elimina el punto
        const price = priceTest.replace(/\./g, '')

        if (price) {
          const priceNew = price.replace('$', '')

          if (priceNew > max) {
            adding(idBackend, price)

            setError('El precio no debe ser mayor a 9999.99')
            setErrorId(idBackend)
            setPrice('')
            setIdBackend('')

            return
          }
        }
        adding(idBackend, price)

        return
      }

      adding(idBackend, priceTest)
      setPrice('')
      setIdBackend('')

      return
    }

    if (!regEx.test(priceValue)) {
      setError('El valor ingresado no es válido.')
      setErrorId(idBackend)
      setPrice('')
      setIdBackend('')

      return
    } else if (priceValue <= min) {
      setError('El precio no debe ser 0')
      setErrorId(idBackend)
      setPrice('')
      setIdBackend('')

      return
    } else if (priceValue >= max) {
      setError('El precio no debe ser mayor a 9999,99')
      setErrorId(idBackend)
      setPrice('')
      setIdBackend('')

      return
    } else if (priceValue.includes(',')) {
      const price = priceValue.split(',')[0]

      if (price > max) {
        setError('El precio no debe ser mayor a 9999,99')
        setErrorId(idBackend)
        setPrice('')
        setIdBackend('')

        return
      }
    }
    if (priceValue === '0,0' || priceValue === '0,00') {
      setError('El precio no debe ser 0')
      setErrorId(idBackend)
      setPrice('')
      setIdBackend('')

      return
    }

    if (priceValue.includes(',') && priceValue.includes('.')) {
      const price = priceValue.replace('.', '')

      priceTest = '$' + price.replace(/(\d{2})\d+$/, '$1')

      adding(idBackend, priceTest)

      setError('')
      setPrice('')
      setIdBackend('')

      return
    }

    if (priceValue.includes(',')) {
      priceTest = '$' + priceValue.replace(/(\d{2})\d+$/, '$1')

      // Si tiene un solo despues de la coma agregar un 0 al final
      if (priceValue.split(',')[1].length === 1) {
        priceTest = priceTest + '0'
      }
    } else {
      priceTest = '$' + priceValue
    }

    if (priceTest.includes('.')) {
      // si el precio tiene punto, se elimina el punto
      const price = priceTest.replace(/\./g, '')

      if (price) {
        const priceNew = price.replace('$', '')

        if (priceNew > max) {
          adding(idBackend, price)

          setError('El precio no debe ser mayor a 9999.99')
          setErrorId(idBackend)
          setPrice('')
          setIdBackend('')

          return
        }
      }
      adding(idBackend, price)

      return
    }
    adding(idBackend, priceTest)

    setError('')
    setPrice('')
    setIdBackend('')
  }

  /**
   * It takes in an id and a price, and if the id is found in the object, it updates the price,
   * otherwise it adds a new object to the array
   * @param id - the id of the product
   * @param price - the price of the product
   * @returns the setObject function.
   */
  const adding = (id, price) => {
    const product = object.find((product) => product.id === id)

    if (product) {
      product.price = price.slice(1)
      setPrice(price)

      setObject([...object])

      return
    }

    setPrice(price)
    price = price.replace('$', '')

    return setObject([
      ...object,
      {
        id,
        price,
        brand: productsDescrtion.brand,
        material: productsDescrtion.material,
        returnability: productsDescrtion.returnability,
        volume: productsDescrtion.volume
      }
    ])
  }

  /**
 * It returns the price of a product if it exists
 * @param id - The id of the product you want to get the price of.
 * @returns The price of the product.
 */
  const obteniendoPrecio = (id) => {
    const product = object.find((product) => product.id === id)

    if (product) {
      const price = '$' + product.price

      if (price === '$') {
        return ''
      }

      return price
    }
  }

  /**
 * It sets the errorId and error state to empty strings
 */
  const timeoutError = () => {
    setErrorId('')
    setError('')
  }

  /**
   * It prevents the default action of the form, then checks if all the prices are empty, if they are,
   * it sets an error message, if not, it filters the object to remove the empty prices, then sets the
   * error message to empty, and finally, it stores the object in session storage and navigates to the
   * next page
   * @param e - the event object
   */
  const handleSubmit = (e) => {
    e.preventDefault()

    const verifyPrices = object.every((item) => {
      return item.price === ''
    })

    if (verifyPrices) {
      setErrorProducts(
        'Es necesario completar al menos el precio de un producto para continuar.'
      )

      setTimeout(() => {
        setErrorProducts('')
      }, 1500)

      return
    }

    // si el precio de un producto esta vacio, se elimina del objeto
    const newObject = object.filter((item) => {
      return item.price !== ''
    })

    // Si existe algun error no dejarlo continuar
    if (error !== '') {
      setError(
        'Es necesario corregir los errores para continuar.'
      )

      setTimeout(() => {
        setError('')
      }
      , 1500)

      return
    }

    const geoArea = JSON.parse(sessionStorage.getItem('geoAreaSelect'))
    const userArea = JSON.parse(sessionStorage.getItem('user'))

    const geoAreaIdUser = userArea.preferences === null ? null : userArea.preferences.geoArea.geoAreaId

    const arrayProducts = []

    // cambiar todos los precios de los newobject si tienen coma por punto

    newObject.forEach((item) => {
      const price = item.price.replace(',', '.')
      const parsePrice = parseFloat(price)

      // agregar al array el id y el precio
      arrayProducts.push({
        geoAreaId: geoAreaIdUser !== null ? geoAreaIdUser : geoArea.geoAreaId,
        productId: item.id,
        price: parsePrice
      })
    })

    clientAxios.post('/survey/validate-prices', arrayProducts)
      .then((res) => {
        if (res.data.length > 0) {
          setAverage(res.data)
          sessionStorage.setItem('products', JSON.stringify(newObject))

          onOpen()

          return
        }
        if (res.data.length === 0) {
          sessionStorage.setItem('products', JSON.stringify(newObject))
          navigate('/details')
        }
      })
      .catch((err) => {
        if (err.response.status === 500) {
          onOpen()
        }
      })
  }

  return (
    <Stack alignItems={'center'} justifyContent={'center'} mx={'auto'}>
      <Box padding={4}>
        <Image
          alt='quilmes'
          h={'auto'}
          src={quilmesImages('./logo.svg')}
          w={'auto'}
        />
      </Box>
      <Divider />
      <Stack
        justifyContent='center'
        mx={'auto'}
        w={{ base: '100%', md: '100%' }}
      >
        <VStack
          as={'form'}
          autoComplete='off'
          w={{ base: '100%', md: '100%' }}
          onSubmit={handleSubmit}
        >
          <Flex
            alignItems='center'
            gap='2'
            minWidth={{ base: '100%', md: 'max-content' }}
            paddingBottom={4}
            paddingTop={{ md: '2' }}
            {...(isLargerThan768
              ? { flexDirection: 'column', width: '100%' }
              : { flex: 'row', width: '90%' })}
          >
            <Box {...(isLargerThan768 ? { width: '100%' } : {})}>
              { !isLargerThan768 &&
              <Link to={'/survey-information'} onClick={handleReturn}>
                <ArrowBackIcon
                  color={'#0A0808'}
                  h={6}
                  marginLeft={6}
                  marginTop={2}
                  w={6}
                />
              </Link>
              }
            </Box>
            <Spacer />
            <Box
              display={'flex'}
              {...(isLargerThan768
                ? { width: '90%', paddingRight: '0' }
                : { paddingRight: '1.2rem' })}
            >
              { !isLargerThan768
                ? <InputGroup
                  borderRadius={'none'}
                  {...(!isLargerThan768 ? { marginRight: '1rem' } : {})}
                >
                  {search === ''
                    ? (
                      <InputRightElement
                        bgColor={'whiteAlpha.100'}
                        border={'none'}
                        borderRadius={'none'}
                      >
                        <SearchIcon color='blackAlpha.700' />
                      </InputRightElement>
                    )
                    : (
                      <InputRightElement
                        bgColor={'whiteAlpha.100'}
                        border={'none'}
                        borderRadius={'none'}
                        cursor={'pointer'}
                        onClick={() => setSearch('')}
                      >
                        <SmallCloseIcon color='#BABABA' />
                      </InputRightElement>
                    )}

                  <Input
                    borderRadius={'10px'}
                    className='search'
                    placeholder='Buscar'
                    type='text'
                    value={search}
                    onChange={handleSearch}
                    onFocus={Checked.length > 0 ? () => setChecked([]) : ''}
                  />
                </InputGroup>
                : <Box display={'flex'} flexDirection={'row'} gap={4} width={'100%'}>
                  <InputGroup
                    borderRadius={'none'}
                    width={'65%'}
                  >
                    {search === ''
                      ? (
                        <InputRightElement
                          bgColor={'whiteAlpha.100'}
                          border={'none'}
                          borderRadius={'none'}
                        >
                          <SearchIcon color='blackAlpha.700' />
                        </InputRightElement>
                      )
                      : (
                        <InputRightElement
                          bgColor={'whiteAlpha.100'}
                          border={'none'}
                          borderRadius={'none'}
                          cursor={'pointer'}
                          onClick={() => setSearch('')}
                        >
                          <SmallCloseIcon color='#BABABA' />
                        </InputRightElement>
                      )}

                    <Input
                      borderRadius={'10px'}
                      className='search'
                      placeholder='Buscar'
                      type='text'
                      value={search}
                      onChange={handleSearch}
                      onFocus={Checked.length > 0 ? () => setChecked([]) : ''}
                    />
                  </InputGroup>
                  <Box
                    alignItems={'center'}
                    display={'flex'}
                    gap={2}
                    justifyContent={'center'}
                  >
                    {sizes.map((sizeS) => (
                      <FilterCheckboxMobile
                        key={sizeS}
                        Checked={Checked}
                        productsApi={productsArea}
                        setChecked={setChecked}
                      />
                    ))}
                  </Box>
                </Box>
              }
              {!isLargerThan768
                ? (
                  <Button
                    margin={0}
                    type='submit'
                    variant='btn-quilmes'
                    w={'50%'}
                  >
                    Continuar
                  </Button>
                )
                : null}
            </Box>
          </Flex>

          <Stack
            bg={'#F7F7F7'}
            w={'100%'}
            {...(!isLargerThan768
              ? { paddingBottom: '2rem' }
              : { paddingBottom: '8rem' })}
          >
            <Stack
              background={'#F7F7F7'}
              display={'flex'}
              flexDirection={'row'}
              justifyContent={'center'}
              marginTop={'0rem !important'}
              padding={{ base: '0rem 1rem', md: '0rem 5rem' }}
              w={{ base: '100%', md: '100%' }}
            >
              {!isLargerThan768
                ? (
                  <Box display={'flex'} flexDirection={'column'} width={'20%'}>
                    <Text
                      color={'#0A0808'}
                      fontSize={'24px'}
                      fontWeight={'400'}
                      padding='1rem 0rem .5rem 0rem'
                    >
                      Filtros
                    </Text>

                    <Box
                      display={'flex'}
                      flexDirection={'row'}
                      flexFlow={'wrap'}
                      gap={2}
                      marginBottom={2}
                    >
                      {Checked.length > 0 &&
                      Checked.map((product, index) => (
                        <Button
                          key={index}
                          _active={{ bg: '#F4E7DF' }}
                          _hover={{ bg: '#F4E7DF' }}
                          bg={'#F4E7DF'}
                          border={'1px solid #DB580B'}
                          color={'#DB580B'}
                          fontWeight={600}
                          marginBottom={2}
                          rightIcon={<CloseIcon h={3} marginBottom={'.1rem'} w={3} />}
                          w={'max-content'}
                          onClick={() => {
                            const newChecked = Checked.filter(
                              (item) => item !== product
                            )

                            setChecked(newChecked)
                          }}
                        >
                          {product}
                        </Button>
                      ))}
                    </Box>

                    <Box display={'flex'} flexDirection={'column'} width={'100%'}>
                      <FilterCheckbox
                        key={sizes}
                        Checked={Checked}
                        filteredProducts={filteredProducts}
                        productsApi={productsArea}
                        setChecked={setChecked}
                      />
                    </Box>
                  </Box>
                )
                : null}

              <Box
                className='container-bar'
                display={'flex'}
                flexDirection={'row'}
                flexWrap={'wrap'}
                h='auto'
                justifyContent={'space-around'}
                overflow='auto'
                padding={{ base: '1rem 0rem', md: '1rem 1rem' }}
                w={{ base: '100%', md: '90%' }}
              >

                {filteredProducts.length > 0
                  ? <SimpleGrid
                    columns={[2, 3, 4, 5]}
                    height={'fit-content'}
                    spacing='20px'
                  >
                    {filteredProducts
                      .sort((a, b) =>
                        a.brand.description.toLowerCase() <
                        b.brand.description.toLowerCase()
                          ? -1
                          : 1
                      )
                      .map((item) => (
                        <FormControl
                          key={item.id}
                          background={'#FFF'}
                          borderRadius={'10px'}
                          display={'flex'}
                          flexDirection={'row'}
                          flexWrap={'wrap'}
                          height={'fit-content'}
                          isInvalid={item.id === errorId ? error : null}
                          justifyContent={'space-between'}
                          marginTop={'0.5rem'}
                          paddingBottom={'.5rem'}
                          w={'100%'}
                          onBlur={() =>
                            priceValue === '' ? timeoutError() : null
                          }
                          onFocus={() => timeoutError()}
                          onKeyDown={(e) => {
                            if (e.key === '.') {
                              e.preventDefault()
                            }
                          }}
                        >
                          <Stack
                            display={'flex'}
                            flexDirection={'row'}
                            justifyContent={'space-between'}
                          >
                            <Box w={'100%'}>
                              <Box
                                display={'flex'}
                                flexDirection={'row'}
                                justifyContent={'space-between'}
                              >
                                <Text
                                  fontSize='sm'
                                  fontWeight='bold'
                                  height={'42px'}
                                  marginLeft={2}
                                  marginTop={3}
                                  width={'70%'}
                                >
                                  {item.brand.description}
                                </Text>
                                <ProductImage item={item} />
                              </Box>
                              <Text marginLeft={2} marginTop={0}>
                                {item.volume.description}
                              </Text>
                              <Stack marginLeft={2} marginTop={2}>
                                <Badge
                                  bg={'#E1E1E1'}
                                  borderRadius={'10px'}
                                  color={'#3B3939'}
                                  fontSize={'10px'}
                                  fontWeight={'400'}
                                  padding={'.1rem .8rem'}
                                  w={'max-content'}
                                >
                                  {item.material.description }
                                </Badge>
                                <Badge
                                  bg={'#E1E1E1'}
                                  borderRadius={'10px'}
                                  color={'#3B3939'}
                                  fontSize={'10px'}
                                  fontWeight={'400'}
                                  padding={'.1rem .8rem'}
                                  w={'max-content'}
                                >
                                  {item.returnability.description}
                                </Badge>
                              </Stack>
                              <Box
                                paddingBottom={1}
                                paddingLeft={2}
                                paddingRight={2}
                                paddingTop={6}
                              >
                                <Input
                                  borderColor={
                                    erroresId.includes(item.id) ? '#FF883F' : '#CBD5E0'
                                  }

                                  placeholder='$ Precio'
                                  value={
                                    item.id === idBackend
                                      ? priceValue
                                      : obteniendoPrecio(item.id)
                                  }
                                  w={'100%'}
                                  onBlur={addingProduct}
                                  onChange={(e) => {
                                    handleChange(e, item.id)
                                  }}
                                  onFocus={() => {
                                    handleFocus(item.id)
                                    const newErroresId = erroresId.filter(
                                      (id) => id !== item.id
                                    )

                                    setErroresId(newErroresId)
                                  }}
                                />
                              </Box>
                            </Box>
                          </Stack>
                        </FormControl>
                      ))}
                  </SimpleGrid>

                  : <Box
                    alignItems={'center'}
                    display={'flex'}
                    flexDirection={'column'}
                    h={'100%'}
                    paddingTop={'2rem'}
                    w={'100%'}
                  >
                    <Text
                      color={'#3B3939'}
                      fontWeight={'400'}
                      marginTop={'3rem'}
                      {...(isLargerThan768
                        ? { fontSize: '16px', textAlign: 'center' }
                        : { fontSize: '24px' })}
                    >
                      No encontramos resultados para tu búsqueda.
                    </Text>
                    <Image
                      marginTop={'2rem'}
                      src={quilmesImages('./errorProducts.svg')}
                      {...(isLargerThan768
                        ? { width: '75%' }
                        : { width: '25%' })}
                    />
                  </Box>
                }
              </Box>
            </Stack>
          </Stack>

          {isLargerThan768
            ? (
              !edit
                ? (
                  <Stack
                    alignItems={'center'}
                    bg={'#F7F7F7'}
                    bottom={0}
                    justifyContent={'center'}
                    marginTop={'-.5rem !important'}
                    paddingBottom={'2rem'}
                    paddingTop='2rem'
                    position={'fixed'}
                    w={'100%'}
                  >
                    {filteredProducts.length !== 0 && (
                    <Button
                      margin={0}
                      marginBottom={'1rem'}
                      type='submit'
                      variant='btn-quilmes'
                      w={'90%'}
                    >
                      Continuar
                    </Button>
                    )}
                  </Stack>
                )
                : null
            )
            : null}

          <AlertDialog
            isCentered
            closeOnOverlayClick={false}
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            motionPreset='slideInBottom'
            onClose={onClose}
          >
            <AlertDialogOverlay />

            <AlertDialogContent>
              <AlertDialogBody paddingTop={'1rem'}>
                Algunos de los precios son muy altos o muy bajos comparados al promedio de relevamientos anteriores.
              </AlertDialogBody>
              <AlertDialogFooter
                alignItems={'center'}
                display={'flex'}
                flexDirection={'row'}
                gap={'1rem'}
                justifyContent={'center'}
              >
                <Button
                  ref={cancelRef}
                  _active={{ bg: '#FFF' }}
                  _focus={{ boxShadow: 'none' }}
                  _hover={{ bg: '#FFF' }}
                  bg={'#FFF'}
                  border={'1px solid #DB580B'}
                  color={'#DB580B'}
                  width={'100%'}
                  onClick={onClose}
                >
                  Revisar precios
                </Button>

                <Box width={'100%'}>
                  <Link to='/details'>
                    <Button fontSize={'16px'} marginTop={'0rem'} variant={'btn-quilmes'} width={'100%'} >
                      Continuar
                    </Button>
                  </Link>
                </Box>

              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>

          {errorProducts &&
            toast(
              (t) => (
                <Flex>
                  {errorProducts}
                  <CloseButton onClick={() => toast.dismiss(t.id)} />
                </Flex>
              ),
              { id: 'errorProducts' }
            )}

          {error &&
            toast(
              (t) => (
                <Flex>
                  <Text paddingTop={1.5}>{error}</Text>
                  <CloseButton
                    className='icon-close'
                    onClick={() => toast.dismiss(t.id)}
                  />
                </Flex>
              ),
              { id: 'error' }
            )}
          <Toaster
            position={'bottom-center'}
            toastOptions={{
              duration: 2000,
              style: {
                color: '#FFFFFF',
                backgroundColor: '#3B3939'
              }
            }}
          />
        </VStack>
      </Stack>
    </Stack>
  )
}

export default Products
